
export class EntryImage {
    title: string;
    description: string;
    unframedWidth: number;
    unframedHeight: number;
    framedWidth: number;
    framedHeight: number;
    imgurl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
    tnImgUrl = '';
    undersize = true;
}
